import { render } from "./Bookmark.vue?vue&type=template&id=477c15d4&ts=true"
import script from "./Bookmark.vue?vue&type=script&lang=ts"
export * from "./Bookmark.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "@/styles/components/header.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__